export const LEVEL_NICKNAMES: Record<number, string> = {
  0: "Newcomer",
  1: "Explorer", 
  2: "Apprentice",
  3: "Skilled Worker",
  4: "Expert",
  5: "Master",
  6: "Veteran",
  7: "Elite",
  8: "Champion",
  9: "Legend",
  10: "Grandmaster"
};

export const getLevelNickname = (level: number): string => {
  if (level >= 10) {
    return `Grandmaster ${level - 9}`;
  }
  return LEVEL_NICKNAMES[level] || "Unknown";
};

export const getXPForLevel = (level: number): number => {
  return level * 500;
};

export const getLevelFromXP = (xp: number): number => {
  return Math.floor(xp / 500);
};